module.exports = __webpack_public_path__ + "img/dashboardin.57744c50.svg";